import * as types from '@store/types'
import graphQL from '@queries'
import PaginatedBannersQuery from '@queries/PaginatedBanners'

const state = {
  list: [],
  options: {
    page: 0
  },
  info: {
    quantity: 0
  }
}

const getters = {
  [types.SHOWCASE_OPTIONS]: (state) => state.options,
  [types.SHOWCASE_LIST]: ({ list }) => list,
  [types.SHOWCASE_INFO]: (state) => state.info
}

const mutations = {
  [types.SHOWCASE_INFO]: (state, payload) => {
    state.info = payload
  },
  [types.SHOWCASE_OPTIONS]: (state, payload) => {
    state.options = payload
  },
  [types.SHOWCASE_LIST]: (state, payload) => {
    state.list = payload
  }
}

const actions = {
  [types.SHOWCASE_LIST]: async ({ commit }, payload = {}) => {
    const params = {
      ...payload,
      result: true,
      page: 1
    }

    commit(types.IS_FETCHING_CAMPAIGNS, true)
    commit(types.SHOWCASE_OPTIONS, params)
    let banners = []
    let quantity = 0

    const response = await graphQL(PaginatedBannersQuery, params)

    if (response && response.data && response.data.data && response.data.data.paginatedBanners) {
      banners = response.data.data.paginatedBanners.data
      quantity = response.data.data.paginatedBanners.quantity
    }

    commit(types.IS_FETCHING_CAMPAIGNS, false)
    commit(types.BREADCRUMB_NAMES, { '/vitrine': (params.tag || '').replace('-', ' ') })
    commit(types.SHOWCASE_LIST, banners)
    commit(types.SHOWCASE_INFO, {
      quantity
    })
  },
  [types.SHOWCASE_INCREASE]: async ({ commit, getters }) => {
    const { quantity } = getters[types.SHOWCASE_INFO]
    const banners = getters[types.SHOWCASE_LIST]

    if (banners.length >= quantity) { return true }

    let options = getters[types.SHOWCASE_OPTIONS]
    options = {
      ...options,
      page: options.page + 1
    }

    commit(types.SHOWCASE_OPTIONS, options)
    let newresults = []

    const results = await graphQL(PaginatedBannersQuery, options)

    if (results.data && results.data.data && results.data.data.paginatedBanners) {
      newresults = results.data.data.paginatedBanners.data
    }
    commit(types.SHOWCASE_LIST, [...banners, ...newresults])
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/showcase.js